export enum RewardListType {
  List,
  Carousel,
}

export enum RewardCardType {
  Default = 'Default',
  Claimable = 'Claimable',
  Competition = 'Competition',
  Locked = 'Locked'
}
export enum RewardsOverlayType {
  OptIn,
  OptOut,
}

export enum ClaimCard {
  Reward = 'Reward',
  Competition = 'Competition',
  Premium = 'Premium',
  Earn = 'Earn',
  Earned = 'Earned',
  PremiumExperience = 'PremiumExperience', 
}

export enum RewardStatus {
  Expired = 'Expired',
  Claimed = 'Claimed',
  Available = 'Available',
}

export enum RewardContentType {
  Rewards = 'Rewards',
  EarnStars = 'EarnStars',
  WinnersCircle = 'WinnersCircle',
}

export enum PremiumCardType {
  Premium,
  Earn,
  Earned,
}

export enum ClaimOutcome {
  None = 'none',
  Success = 'success',
  Fail = 'fail',
}